/* eslint-disable no-unused-vars */
import React, { useEffect, useState, useCallback } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import {
  Search, Edit, Archive, RotateCcw, Flag, FlagOff, Send, History,
  RefreshCw, BarChart3, ListChecks, AlertTriangle, Loader2, Eye,
} from 'lucide-react';

import { Card, CardContent, CardHeader, CardTitle } from './ui/card';
import { Button } from './ui/button';
import { Input } from './ui/input';
import { Textarea } from './ui/textarea';
import { Label } from './ui/label';
import { Badge } from './ui/badge';
import { Tabs, TabsContent, TabsList, TabsTrigger } from './ui/tabs';
import {
  Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle,
} from './ui/dialog';
import {
  Select, SelectContent, SelectItem, SelectTrigger, SelectValue,
} from './ui/select';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api/super-admin/communityplace`;

export const getAuthHeader = () => {
  const t = localStorage.getItem('token')
    || localStorage.getItem('access_token')
    || localStorage.getItem('admin_token');
  return t ? { Authorization: `Bearer ${t}` } : {};
};

export const STATUTS = ['publiee', 'achetee', 'assignee', 'archivee', 'suspended'];
export const FLAG_CATEGORIES = [
  { value: 'abus', label: 'Abus' },
  { value: 'spam', label: 'Spam' },
  { value: 'fake', label: 'Faux lead' },
  { value: 'doublon', label: 'Doublon' },
  { value: 'autre', label: 'Autre' },
];

export function formatDate(iso) {
  if (!iso) return '—';
  try { return new Date(iso).toLocaleString('fr-FR', { dateStyle: 'short', timeStyle: 'short' }); }
  catch { return iso; }
}

export function formatEUR(n) {
  if (n === null || n === undefined) return '—';
  return Number(n).toLocaleString('fr-FR', { style: 'currency', currency: 'EUR' });
}

export function StatusBadge({ demande }) {
  if (demande.is_archived) return <Badge variant="outline" className="bg-gray-100 text-gray-700 font-semibold">Archivée</Badge>;
  if (demande.is_flagged) return <Badge variant="destructive" data-testid={`status-flagged-${demande.id}`}>🚨 Signalée</Badge>;
  if (demande.is_suspended) return <Badge variant="outline" className="bg-amber-100 text-amber-800 font-semibold">Suspendue</Badge>;
  if (demande.is_assigned) return <Badge className="bg-emerald-600 text-white font-semibold">Assignée</Badge>;
  return <Badge className="bg-blue-600 text-white font-semibold">Publiée</Badge>;
}

// =============================================================================
// MAIN PANEL
// =============================================================================
